export default function(model, settings) {
    let result = null;

    if (model && settings) {
        const eventId = model.hint_event,
            events = settings.get('events');

        if (events[eventId]) {
            result = parseInt(events[eventId].categoryId);
        }
    }

    return result;
}
